<template>

    <form ref="instituicaoensinoestagio-form-batch-create" v-on:submit.prevent="executeBatchCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="cursoId">Curso</label>
                <select v-model="model.cursoId" class="form-control" name="cursoId" required>
                    <option value="">Selecione um curso</option>
                    <option v-for="curso in cursos" :key="curso.cursoId" :value="curso.cursoId">
                        {{ curso.nome }}
                    </option>
                </select>
            </div>

            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="vendaLiberada" class="custom-control-input" v-model="model.vendaLiberada">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Venda Liberada?</span>
                </label>
            </div>

            <div class="form-group col-md-12">
                <label for="valorMaterialDidaticoInstituicao">Valor Material Didático Instituição</label>
                <money v-bind="money" class="form-control" name="valorMaterialDidaticoInstituicao" placeholder="Valor Material Didático Instituição" v-model="model.valorMaterialDidaticoInstituicao" required />
            </div>

            <div class="form-group col-md-12">
                <label for="valorMaterialDidaticoAluno">Valor Material Didático Aluno</label>
                <money v-bind="money" class="form-control" name="valorMaterialDidaticoAluno" placeholder="Valor Material Didático Aluno" v-model="model.valorMaterialDidaticoAluno" required />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeBatchCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensinoestagio-form-batch-create",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {
                cursoId: '',
                vendaLiberada: true,
                valorMaterialDidaticoInstituicao: 0,
                valorMaterialDidaticoAluno: 0
            },

            cursos: [],

            form: "instituicaoensinoestagio-form-batch-create",

            resources: {
                cursos: 'curso',
                batchCreate: 'instituicaoensinoestagio/batch-create',
            },

        }),

        methods: {

            executeBatchCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                this.model.instituicaoEnsinoId = this.$props.id;

                new Api(this.resources.batchCreate).post(model).then(data => {
                    this.$emit('on-saved', data)

                    // Exibe a mensagem retornada pela API
                    if (data.data && data.data.message) {
                        this.defaultSuccessResult(data.data.message);
                    } else {
                        this.defaultSuccessResult('Registros criados em lote com sucesso');
                    }
                }, err => {
                    // Exibe a mensagem de erro retornada pela API
                    if (err && err.data && err.data.message) {
                        this.defaultErrorResult(err.data.message);
                    } else {
                        this.defaultErrorResult(err);
                    }
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

            loadCursos: function () {
                // Carrega todos os cursos ativos
                new Api(this.resources.cursos).get({ ativo: true, pageSize: 1000, isPagination: false }).then(data => {
                    this.cursos = data.dataList || [];
                }, err => {
                    this.defaultErrorResult(err);
                })
            }
        },

        mounted() {
            this.loadCursos();
        }
    };
</script>

